// extracted by mini-css-extract-plugin
var _1 = "ciHUtvBcrgNcv1YFnOo2";
export { _1 as "clickable" }
